const attachmentFilesEquipmentsTypo = {
  label: 'Archivos adjuntos para este equipo',
  noResults: 'Ningún resultado encontrado'
};

export default attachmentFilesEquipmentsTypo;